import {
    ColDef,
    GetRowIdParams,
    ValueFormatterParams,
} from 'ag-grid-community';

import { ChartTemplateTableItemT } from './types';
import { formatDate } from 'helpers/formatHelper';

const TRANSLATION_PREFIX = 'support.chartsTemplates.gridSummary';

export const getRowId = (params: GetRowIdParams) => params.data.key;

export const getColDefs = (t: TranslationT): ColDef[] => [
    {
        field: 'title',
        headerName: t(`${TRANSLATION_PREFIX}.title`),
        flex: 3,
        filter: 'agTextColumnFilter',
        floatingFilter: true,
    },
    {
        field: 'authorizedFunctions',
        headerName: t(`${TRANSLATION_PREFIX}.authorizedFunctions`),
        flex: 2,
        valueFormatter: (params: ValueFormatterParams) =>
            Array.isArray(params.value)
                ? params.value.join(', ')
                : params.value,
        filter: 'agSetColumnFilter',
        floatingFilter: true,
    },
    {
        field: 'authorizedSoftwares',
        headerName: t(`${TRANSLATION_PREFIX}.authorizedSoftwares`),
        flex: 2,
        valueFormatter: (params: ValueFormatterParams) =>
            Array.isArray(params.value)
                ? params.value.join(', ')
                : params.value,
        filter: 'agSetColumnFilter',
        floatingFilter: true,
    },
    {
        field: 'status',
        headerName: t(`${TRANSLATION_PREFIX}.status.title`),
        flex: 1,
        valueFormatter: (params: ValueFormatterParams) =>
            t(`support.chartsTemplates.gridSummary.status.${params.value}`),
        filter: 'agSetColumnFilter',
        floatingFilter: true,
    },
    {
        field: 'createdAt',
        headerName: t(`${TRANSLATION_PREFIX}.createdAt`),
        flex: 1,
        valueFormatter: (params: ValueFormatterParams) =>
            formatDate(new Date(params.value)),
        filter: 'agDateColumnFilter',
        floatingFilter: true,
        filterParams: {
            comparator: (filterDate: Date, cellValue: string | Date) => {
                const cellDate = new Date(cellValue);

                const filterTime = filterDate.setHours(0, 0, 0, 0);
                const cellTime = cellDate.setHours(0, 0, 0, 0);

                if (cellTime < filterTime) return -1;
                if (cellTime > filterTime) return 1;
                return 0;
            },
        },
    },
    {
        field: 'actions',
        headerName: t('common.actions'),
        flex: 1,
        cellRenderer: 'actionsCellRenderer',
        valueGetter: ({ data }: { data: ChartTemplateTableItemT }) => data,
        sortable: false,
    },
];
